export enum ModalSize {
	SM = 'sm',
	MD = 'md',
	LG = 'lg',
	XL = 'xl',
	XXL = 'xxl',
	CONFIRM = 'confirm'
}

export class ModalConfigurationModel {
	title?: string;
	titleIcon?: string;
	confirmLabel?: string;
	confirmClass?: string;
	showBackground?: boolean;
	modalSize?: ModalSize;
	modalCustomClass?: string;
	draggable?: boolean;
	resizable?: boolean;
	fullScreen?: boolean;
	defaultFullScreen?: boolean;
	// Helps to determinate default values
	_defaultShowBackground ? = true;
	// Function te be executed when user does a double click over the dialog
	// Can be used by the view to do actions like change from show to edit, or custom actions
	onDoubleClick?: () => void;

	constructor() {
		this.showBackground = this._defaultShowBackground;
		this.modalSize = ModalSize.SM;
	}

	/**
	 * Change the default
	 * @param showBackground
	 */
	public setDefaultShowBackground?(value: boolean): void {
		this._defaultShowBackground = value;
	}

	/**
	 * Get the Default State
	 */
	public getDefaultShowBackground?(): boolean {
		return this._defaultShowBackground;
	}
}
